import Dialog from 'material-ui/Dialog';
import React from 'react';
import user1 from '../../../../img/noimage.png';

export const ProfileModal = (props) => {
  return (
        <div>
        <Dialog className="custom_modal"
            modal={false}
            open={props.openImage}
            contentStyle={{ 'width': '30%' }}
            onRequestClose={props.closeDialog}
            >
                <img src={props.profileFullPicture ? props.profileFullPicture : user1} alt="" width="100%" height="100%" />
            </Dialog>
        </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/common/displayProfile.js